module.exports = __webpack_public_path__ + "img/itsm-banner.c2a25afb.png";